import { environment } from "src/environments/environment";
import { informes, procedimientos } from "./models";




var documentos = [];
/*
{
        id: 'anexo_1',
        icon: 'fa band-aid',
        text: procedimiento2.proc.text,
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: 'control_documentos', fatherId: 'anexo_1', text: procedimiento2.reg.uno.text , isSelected: false
            },
            {
                id: 'reuniones', fatherId: 'otros', text: 'Anexo III Listado de reuniones', isSelected: false
            }
        ]
    },
*/

var procedimientoLocatecQualitapp = {
  id: 'procedimiento_1',
  icon: 'fa fa-file',
  text: 'P.01 CONTROL DE DOCUMENTOS',
  description: 'procedimiento',
  isSelected: false,
  informes : [
    {
      id: 'control_documentos',
      title: 'Control de documentos',
      full_title: 'Anexo II Control de documentos',
      procedimiento: 'P.01',
      procedimiento_num: '01',
      registro: 'Anexo II',
      registro_num: 'II',
      revision: 'Rev.01',
      revision_num: '01'
    }
  ]
}

var procedimientoMantenimiento = {
  id: "mantenimiento-vehiculos",
  icon: 'fa fa-truck',
  text: 'P.01 Gestión de Vehículos',
  description: 'vehiculos',
  isSelected: false,
  informes : [
    {
      id: 'vehiculos',
      title: 'Camiones',
      full_title: 'Camiones'
    },
        {
      id: 'mantenimiento-camiones',
      title: 'Mantenimiento vehículos',
      full_title: 'Mantenimiento vehículos',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
      database: 'mantenimiento_camion'

    },
  ]
}


var procedimiento1 = {
  id: 'procedimiento_1',
  icon: 'fa fa-file',
  text: 'P.01 CONTROL DE DOCUMENTOS',
  description: 'procedimiento',
  isSelected: false,
  informes: [
    {
      id: 'control_documentos',
      title: 'Control de documentos',
      full_title: 'Anexo II Control de documentos',
      procedimiento: 'P.01',
      procedimiento_num: '01',
      registro: 'Anexo II',
      registro_num: 'II',
      revision: 'Rev.01',
      revision_num: '01'
    },
    {
      id: 'reuniones',
      title: 'Listado de reuniones',
      full_title: 'Anexo III Listado de reuniones',
      procedimiento: 'P.01',
      procedimiento_num: '01',
      registro: 'Anexo III',
      registro_num: 'III',
      revision: 'Rev.01',
      revision_num: '01',
      database: 'reunion'
    },

    {
      id: 'control_certificados',
      title: 'Control de certificados',
      full_title: 'Control de certificados',
      procedimiento: 'P.01',
      procedimiento_num: '01',
      registro: '',
      registro_num: '',
      revision: 'Rev.01',
      revision_num: '01'
    },
  ]
};

var procedimiento2 = {
  id: 'procedimiento_2',
  icon: 'fa fa-shower',
  text: 'P.02 LIMPIEZA Y DESINFECCIÓN',
  description: 'procedimiento',
  isSelected: false,
  informes: [
    {
      id: 'limpieza',
      title: 'Control de limpieza y desinfección',
      full_title: 'Anexo II Control de limpieza y desinfección',

      procedimiento: 'P.02',
      procedimiento_num: '02',
      registro: 'Anexo II',
      registro_num: 'II',
      revision: 'Rev.',
      revision_num: ''
    },
    {
      id: 'limpieza_desinfeccion',
      title: 'Limpieza y desinfección -camiones-',
      full_title: 'Anexo II.bis Limpieza y desinfección -camiones-',
      procedimiento: 'P.02',
      procedimiento_num: '02',
      registro: 'Anexo II.bis',
      registro_num: 'II.bis',
      revision: 'Rev.',
      revision_num: ''
    },
    {
      id: 'plan_limpieza_desinfeccion',
      title: 'Plan de limpieza y desinfección',
      full_title: 'Anexo III Plan de limpieza y desinfección',

      procedimiento: 'P.02',
      procedimiento_num: '02',
      registro: 'Anexo III',
      registro_num: 'III',
      revision: 'Rev.',
      revision_num: ''
    },
    {
      id: 'encuesta_higiene',
      title: 'Encuesta de higiene',
      full_title: 'Anexo V Encuesta de higiene',
      procedimiento: 'P.02',
      procedimiento_num: '02',
      registro: 'Anexo V',
      registro_num: 'V',
      revision: 'Rev.',
      revision_num: ''
    }
  ]


};


var procedimiento4 = {
  id: 'procedimiento_4',
  icon: 'fa fa-quora',
  text: 'P.04 CONTROL DE CALIDAD',
  description: 'procedimiento',
  isSelected: false,
  /*
  {id: 'etiquetas', fatherId: 'anexo_4', text: procedimiento4.reg.seis.text, isSelected: false}, */
  informes: [
    {
      id: 'zumos',
      title: 'Ensayo de contenido en zumos e índice y madurez',
      full_title: 'Anexo I  Ensayo de contenido en zumos e índice y madurez',
      procedimiento: 'P.04',
      procedimiento_num: '04',
      registro: 'Anexo I',
      registro_num: 'I',
      revision: 'Rev.',
      revision_num: ''
    },
    {
      id: 'producto',
      title: 'Control de entradas de materia prima',
      full_title: 'Anexo III Control de entradas de materia prima',
      procedimiento: 'P.04',
      procedimiento_num: '04',
      registro: 'Anexo III',
      registro_num: 'III',
      revision: 'Rev.',
      revision_num: '',
      database: 'materia_prima'
    },
    {
      id: 'test-de-vida-comercial',
      title: 'Test de vida comercial',
      full_title: 'Anexo IV Test de vida comercial',
      procedimiento: 'P.04',
      procedimiento_num: '04',
      registro: 'Anexo IV',
      registro_num: 'IV',
      revision: 'Rev.',
      revision_num: '',
      database: 'test_vida_comercial'
    },
    {
      id: 'control-de-conformidad',
      title: 'Control de conformidad',
      full_title: 'Anexo V Control de conformidad',
      procedimiento: 'P.04',
      procedimiento_num: '04',
      registro: 'Anexo V',
      registro_num: 'V',
      revision: 'Rev.',
      revision_num: '',
      database: 'conformidad'
    },
    {
      id: 'etiquetas',
      title: 'Control de etiquetas',
      full_title: 'Anexo VI Control de etiquetas',
      procedimiento: 'P.04',
      procedimiento_num: '04',
      registro: 'Anexo VI',
      registro_num: 'VI',
      revision: 'Rev.',
      revision_num: '',
      database: 'control_etiquetas'
    },
    {
      id: 'pesos',
      title: 'Registro de control de pesos pitufo',
      full_title: 'Anexo VII Registro de control de pesos pitufo',
      procedimiento: 'P.04',
      procedimiento_num: '04',
      registro: 'Anexo VII',
      registro_num: 'VII',
      revision: 'Rev.',
      revision_num: '',
      database: 'PesoPitufo'
    },
    {
      id: 'girsac',
      title: 'Registro de control de pesos malla (girsac)',
      full_title: 'Anexo VII.bis Registro de control de pesos malla (girsac)',
      procedimiento: 'P.04',
      procedimiento_num: '04',
      registro: 'Anexo VII.bis',
      registro_num: 'VII.bis',
      revision: 'Rev.',
      revision_num: '',
      database: 'PesoGirsac'
    }

  ]


};


var procedimiento5 = {
  id: 'procedimiento_5',
  icon: 'fa fa-building',
  text: 'P.05 CONTROL DE INFRAESTRUCTURAS, BIENES Y EQUIPOS',
  description: 'P.05',
  isSelected: false,
  informes: [
    {
      id: 'control',
      title: 'Control de cristales, plásticos, luces y metales',
      full_title: 'Anexo III Control de cristales, plásticos, luces y metales',
      procedimiento: 'P.05',
      procedimiento_num: '05',
      registro: 'Anexo III',
      registro_num: 'III',
      revision: '',
      revision_num: '',
      database: 'plasticos'

    },
    {
      id: 'transporte',
      title: 'Datos del transporte',
      full_title: 'Anexo IV Datos del transporte',
      procedimiento: 'P.05',
      procedimiento_num: '05',
      registro: 'Anexo IV',
      registro_num: 'IV',
      revision: '',
      revision_num: '',
      database: 'datos_transporte'

    },
    {
      id: 'control_linea',
      title: 'Control de línea',
      full_title: 'Anexo V Control de línea',
      procedimiento: 'P.05',
      procedimiento_num: '05',
      registro: 'Anexo V',
      registro_num: 'V',
      revision: '',
      revision_num: '',

    },
    {
      id: 'utensilios',
      title: 'Control utensilios',
      full_title: 'Anexo VIII Control utensilios',
      procedimiento: 'P.05',
      procedimiento_num: '05',
      registro: 'Anexo VIII',
      registro_num: 'VIII',
      revision: '',
      revision_num: '',

    },
    {
      id: 'tiritas',
      title: 'Control de tiritas',
      full_title: 'Anexo IX Control de tiritas',
      procedimiento: 'P.05',
      procedimiento_num: '05',
      registro: 'Anexo IX',
      registro_num: 'IX',
      revision: '',
      revision_num: '',

    },
    {
      id: 'parametro',
      title: 'Control de parámetros en cámaras frigoríficas',
      full_title: 'Anexo XII Control de parámetros en cámaras frigoríficas',
      procedimiento: 'P.05',
      procedimiento_num: '05',
      registro: 'Anexo XII',
      registro_num: 'XII',
      revision: '',
      revision_num: '',

    },
  ]
};

var procedimiento6 = {
  id: 'procedimiento_6',
  icon: 'fa fa-address-book',
  text: 'P.06 AUDITORÍAS INTERNAS',
  description: 'P.06',
  isSelected: false,
  informes: [
    {
      id: 'plan_auditoria',
      title: 'Plan de auditoría',
      full_title: 'Anexo I Plan de auditoría',
      procedimiento: 'P.06',
      procedimiento_num: '06',
      registro: 'Anexo I',
      registro_num: 'I',
      revision: '',
      revision_num: '',

    }
  ]
};

var procedimiento9 = {
  id: 'procedimiento_9',
  icon: 'fa fa-briefcase',
  text: 'P.09 FORMACIÓN',
  description: 'P.09',
  isSelected: false,
  informes: [
    {
      id: 'organigrama_funcional',
      title: 'Organigrama funcional',
      full_title: 'Anexo I Organigrama funcional',
      procedimiento: 'P.09',
      procedimiento_num: '09',
      registro: 'Anexo I',
      registro_num: 'I',
      revision: '',
      revision_num: '',

    },
    {
      id: 'plan_formacion',
      title: 'Plan anual de formación y control de acción formativa',
      full_title: 'Anexo III Plan anual de formación y control de acción formativa',
      procedimiento: 'P.09',
      procedimiento_num: '09',
      registro: 'Anexo III',
      registro_num: 'III',
      revision: '',
      revision_num: '',

    },
    {
      id: 'formacion',
      title: 'Control de formación',
      full_title: 'Anexo IV Control de formación',
      procedimiento: 'P.09',
      procedimiento_num: '09',
      registro: 'Anexo IV',
      registro_num: 'IV',
      revision: '',
      revision_num: '',

    }
  ]
};

var procedimiento14 = {
  id: 'procedimiento_14',
  icon: 'fa fa-exclamation-triangle',
  text: 'P.14 NO CONFORMIDADES',
  description: 'P.14',
  isSelected: false,
  informes: [
    {
      id: 'tratamiento_no_conformidad',
      title: 'Tratamiento de las no conformidades',
      full_title: 'Anexo I Tratamiento de las no conformidades',
      procedimiento: 'P.14',
      procedimiento_num: '14',
      registro: 'Anexo I',
      registro_num: 'I',
      revision: '',
      revision_num: '',

    }
  ]
};

var procedimiento20 = {
  id: 'procedimiento_20',
  icon: 'fa fa-trash',
  text: 'P.20 GESTIÓN DE RESIDUOS',
  description: 'P.20',
  isSelected: false,
  informes: [
    {
      id: 'inventario_residuos',
      title: 'Inventario general de residuos',
      full_title: 'Anexo I Inventario general de residuos',
      procedimiento: 'P.20',
      procedimiento_num: '20',
      registro: 'Anexo I',
      registro_num: 'I',
      revision: '',
      revision_num: '',

    },
    {
      id: 'plano_residuos',
      title: 'Plano gestión de residuos',
      full_title: 'Anexo II Plano gestión de residuos',
      procedimiento: 'P.20',
      procedimiento_num: '20',
      registro: 'Anexo II',
      registro_num: 'II',
      revision: '',
      revision_num: '',

    },
    {
      id: 'residuos_no_peligrosos',
      title: 'Libro registro de residuos no peligrosos',
      full_title: 'Anexo III Libro registro de residuos no peligrosos',
      procedimiento: 'P.20',
      procedimiento_num: '20',
      registro: 'Anexo III',
      registro_num: 'III',
      revision: '',
      revision_num: '',

    },
    {
      id: 'residuos_peligrosos',
      title: 'Libro registro de residuos peligrosos',
      full_title: 'Anexo III.bis Libro registro de residuos peligrosos',
      procedimiento: 'P.20',
      procedimiento_num: '20',
      registro: 'Anexo III.bis',
      registro_num: 'III.bis',
      revision: '',
      revision_num: '',

    }
  ]
};

var procedimiento22 = {
  id: 'procedimiento_22',
  icon: 'fa fa-apple',
  text: 'P.22 CONTROL PRODUCTOS POSTCOSECHA',
  description: 'P.20',
  isSelected: false,
  informes: [
    {
      id: 'control_drencher',
      title: 'Control Productos Postcosecha Drencher',
      full_title: 'Anexo I Control Productos Postcosecha Drencher',
      procedimiento: 'P.22',
      procedimiento_num: '22',
      registro: 'Anexo I',
      registro_num: 'I',
      revision: '',
      revision_num: '',

    },
    {
      id: 'lavadora',
      title: 'Control Productos Postcosecha Lavadora',
      full_title: 'Anexo II Control Productos Postcosecha Lavadora',
      procedimiento: 'P.22',
      procedimiento_num: '22',
      registro: 'Anexo II',
      registro_num: 'II',
      revision: '',
      revision_num: '',

    }, {
      id: 'online',
      title: 'Control Productos Postcosecha Online',
      full_title: 'Anexo III Control Productos Postcosecha Online',
      procedimiento: 'P.22',
      procedimiento_num: '22',
      registro: 'Anexo III',
      registro_num: 'III',
      revision: '',
      revision_num: '',
      database: 'encerado_online'

    },
    {
      id: 'encerado',
      title: 'Control Productos Postcosecha Cera',
      full_title: 'Anexo IV Control Productos Postcosecha Cera',
      procedimiento: 'P.22',
      procedimiento_num: '22',
      registro: 'Anexo IV',
      registro_num: 'IV',
      revision: '',
      revision_num: '',

    },



    {
      id: 'etileno',
      title: 'Control Productos Postcosecha Etileno',
      full_title: 'Anexo V Control Productos Postcosecha Etileno',
      procedimiento: 'P.22',
      procedimiento_num: '22',
      registro: 'Anexo V',
      registro_num: 'V',
      revision: '',
      revision_num: '',

    },
  ]
};

var procedimientoReto = {
  id: 'reto',
  icon: 'fa fa-book',
  text: 'RETO',
  description: 'reto',
  isSelected: false,
  informes: [
    {
      id: 'entidades',
      title: 'Entidades',
      full_title: 'Entidades',
      procedimiento: 'reto',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'transacciones',
      title: 'Transacciones',
      full_title: 'Transacciones',
      procedimiento: 'reto',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    }
  ]
}

var procedimientoOtros = {
  id: 'otros',
  icon: 'fa fa-plus',
  text: 'Otros',
  description: 'otros',
  isSelected: false,
  informes: [




    {
      id: 'transporte-rutas',
      title: 'Transporte rutas',
      full_title: 'Transporte rutas',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
      database: 'transporte_rutas'

    },
    {
      id: 'mantenimiento-camiones',
      title: 'Mantenimiento vehículos',
      full_title: 'Mantenimiento vehículos',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
      database: 'mantenimiento_camion'

    },
    {
      id: 'agua-cloro',
      title: 'Agua cloro',
      full_title: 'Agua cloro',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
      database: 'agua_cloro'

    },
    {
      id: 'agua',
      title: 'Control de Agua',
      full_title: 'Control de Agua',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'nebulizador',
      title: 'Control de nebulizador',
      full_title: 'Control de nebulizador',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'cuaderno_campo',
      title: 'Cuaderno de campo',
      full_title: 'Cuaderno de campo',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
      database: 'cuaderno'

    },
    {
      id: 'confecciones_diarias',
      title: 'Confecciónes diarias',
      full_title: 'Confecciónes diarias',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
      database: 'confeccion'

    },
    {
      id: 'plagas',
      title: 'Control de plagas',
      full_title: 'Control de plagas',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'camaras_etileno',
      title: 'Cámaras de etileno',
      full_title: 'Cámaras de etileno',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    /* {
        id: 'control_linea',
        title: 'Control línea',
        full_title: 'Control línea',
        procedimiento: 'otros',
        procedimiento_num: '',
        registro: '',
        registro_num: '',
        revision: '',
        revision_num: '',

    }, */
    {
      id: 'diario_cogida',
      title: 'Control diario cogida',
      full_title: 'Control diario cogida',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'peso_materia',
      title: 'Control peso entrada materia prima',
      full_title: 'Control peso entrada materia prima',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
      database: 'peso_materia_prima'
    },
    {
      id: 'perdida_peso_diaria',
      title: 'Pérdida diaria de peso en la confección',
      full_title: 'Pérdida diaria de peso en la confección',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'perdida_peso_no_pesada',
      title: 'Registro de entrada materia prima no pesada',
      full_title: 'Registro de entrada materia prima no pesada',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'contra_incendios',
      title: 'Verificación instalaciones de protección contra incendios (anual- trimestral)',
      full_title: 'Verificación instalaciones de protección contra incendios (anual- trimestral)',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },

    {
      id: 'limpieza_cajones',
      title: 'Registro limpieza cajones',
      full_title: 'Registro limpieza cajones',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'micro_fomesa',
      title: 'Micro-Fomesa',
      full_title: 'Micro-Fomesa',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'multiresiduos',
      title: 'Multiresiduos',
      full_title: 'Multiresiduos',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
    },
    {
      id: 'microbiologico',
      title: 'Análisis microbiológico',
      full_title: 'Análisis microbiológico',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'analisis_agua',
      title: 'Análisis de agua',
      full_title: 'Análisis de agua',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'fruto_hueso',
      title: 'Fruta hueso',
      full_title: 'Fruta hueso',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'control_auditoria',
      title: 'Control auditoría',
      full_title: 'Control auditoría',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'balance_control',
      title: 'Balance control de producción diferenciada',
      full_title: 'Balance control de producción diferenciada',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'balance_masas',
      title: 'Balance de masas',
      full_title: 'Balance de masas',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
    },
    {
      id: 'balance_global',
      title: 'Balance de masas Global GAP',
      full_title: 'Balance de masas Global GAP',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
      database: 'balance_masas_global'
    },
    {
      id: 'control_horario',
      title: 'Control horario fruta externa',
      full_title: 'Control horario fruta externa',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
    },
    {
      id: 'factura_agua',
      title: 'Consumo agua potable',
      full_title: 'Consumo agua potable',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
    },
    {
      id: 'factura_gas',
      title: 'Consumo gas',
      full_title: 'Consumo gas',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
    },
    {
      id: 'factura_luz',
      title: 'Consumo electricidad',
      full_title: 'Consumo electricidad',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',
    },
    {
      id: '',
      title: '',
      full_title: '',
      procedimiento: 'otros',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
  ]
};

//Procedimientos Tresfrut
var procedimiento11 = {
  id: 'procedimiento_4',
  icon: 'fa fa-quora',
  text: 'P.11 CONTROL E INSPECCIONES DE PRODUCTO ',
  description: 'procedimiento',
  isSelected: false,
  /*
  {id: 'etiquetas', fatherId: 'anexo_4', text: procedimiento4.reg.seis.text, isSelected: false}, */
  informes: [
    {
      id: 'zumos',
      title: 'Control índice madurez y zumo',
      full_title: 'R01 Control índice madurez y zumo',
      procedimiento: 'P.11',
      procedimiento_num: 'R01 P11',
      registro: 'R01',
      registro_num: '11',
      revision: 'Ed.',
      revision_num: ''
    },
    {
      id: 'producto',
      title: 'Control de entradas de materia prima',
      full_title: 'R02 Control de entradas de materia prima',
      procedimiento: 'P.11',
      procedimiento_num: 'R02 P11 ',
      registro: 'R02',
      registro_num: '11',
      revision: 'Ed.',
      revision_num: ''
    },
    {
      id: 'control-de-conformidad',
      title: 'Control de producto',
      full_title: 'R03 Control de producto',
      procedimiento: 'P.11',
      procedimiento_num: 'R03 P11',
      registro: 'R03',
      registro_num: '11',
      revision: 'Ed.',
      revision_num: ''
    },
    {
      id: 'pesos',
      title: 'Control de procesos',
      full_title: 'R06 Control de procesos',
      procedimiento: 'P.11',
      procedimiento_num: 'R06 P11 ',
      registro: 'R06',
      registro_num: '11',
      revision: 'Ed.',
      revision_num: ''
    },
    {
      id: 'etiquetas',
      title: 'Control de etiquetas',
      full_title: 'R09 Control de etiquetas',
      procedimiento: 'P.11',
      procedimiento_num: 'R09 P11 ',
      registro: 'R09',
      registro_num: '11',
      revision: 'Ed.',
      revision_num: ''
    }

  ]


};

var procedimientoSGA = {
  id: 'sga',
  icon: 'fa fa-building',
  text: 'SGA',
  description: 'sga',
  isSelected: false,
  informes: [
    {
      id: 'sga_productos',
      title: 'Artículos',
      full_title: 'SGA Artículos',
      procedimiento: 'P.22',
      procedimiento_num: '22',
      registro: 'Anexo V',
      registro_num: 'V',
      revision: '',
      revision_num: '',

    },
    {
      id: 'sga_proveedores',
      title: 'Proveedores',
      full_title: 'SGA Proveedores',
      procedimiento: 'P.22',
      procedimiento_num: '22',
      registro: 'Anexo V',
      registro_num: 'V',
      revision: '',
      revision_num: '',

    },
    {
      id: 'sga_ordenes_compra',
      title: 'Ordenes Entrada / Salida',
      full_title: 'SGA Ordenes E/S',
      procedimiento: 'P.22',
      procedimiento_num: '22',
      registro: 'Anexo V',
      registro_num: 'V',
      revision: '',
      revision_num: '',

    }
  ]
};

var procedimientosCampanar = {
  id: 'campanar',
  icon: 'fa fa-building',
  text: 'Campanar',
  description: 'campanar',
  isSelected: false,
  informes: [
    {
      id: 'app_proveedores',
      title: 'Proveedores',
      full_title: 'Proveedores',
      procedimiento: 'P.09',
      procedimiento_num: '09',
      registro: 'Anexo IV',
      registro_num: 'IV',
      revision: '',
      revision_num: '',
    },
    {
      id: 'app_productos',
      title: 'Productos',
      full_title: 'Productos',
      procedimiento: 'P.09',
      procedimiento_num: '09',
      registro: 'Anexo IV',
      registro_num: 'IV',
      revision: '',
      revision_num: '',
    }
  ]
}

let tienda = {
  id: 'app_productos',
  icon: 'fa fa-shopping-bag',
  text: 'Tienda',
  description: 'Todos los productos',
  isSelected: false,
  informes: [
    {
      id: 'app_productos',
      title: 'Productos',
      full_title: 'Productos',
      procedimiento: 'P.09',
      procedimiento_num: '09',
      registro: 'Anexo IV',
      registro_num: 'IV',
      revision: '',
      revision_num: '',
    },
    {
      id: 'app_proveedores',
      title: 'Proveedores',
      full_title: 'Proveedores',
      procedimiento: 'P.09',
      procedimiento_num: '09',
      registro: 'Anexo IV',
      registro_num: 'IV',
      revision: '',
      revision_num: '',
    },
    {
      id: 'envases',
      title: 'Envases',
      full_title: 'Envases',
      procedimiento: 'P.09',
      procedimiento_num: '09',
      registro: 'Anexo IV',
      registro_num: 'IV',
      revision: '',
      revision_num: '',
    }
  ]
}
// var procedimientosCampanarProveedores = {
//   id: 'camproveedores',
//   icon: 'fa fa-building',
//   text: 'Proveedores',
//   description: 'campanar',
//   isSelected: false,
//   informes: [
//     {
//       id: 'app_proveedores',
//       title: 'Proveedores',
//       full_title: 'Proveedores',
//       procedimiento: 'P.09',
//       procedimiento_num: '09',
//       registro: 'Anexo IV',
//       registro_num: 'IV',
//       revision: '',
//       revision_num: '',
//     }
//   ]
// }

// var procedimientosCampanarProductos = {
//   id: 'camproductos',
//   icon: 'fa fa-building',
//   text: 'Productos',
//   description: 'campanar',
//   isSelected: false,
//   informes: [
//     {
//       id: 'app_productos',
//       title: 'Productos',
//       full_title: 'Productos',
//       procedimiento: 'P.09',
//       procedimiento_num: '09',
//       registro: 'Anexo IV',
//       registro_num: 'IV',
//       revision: '',
//       revision_num: '',
//     }
//   ]
// }



export var formularios = [
  [
    {
      procedimiento: '',
      referencia: '',
      referencia_num: '',
      revision: '',
      titulo: '',
    }
  ]
];


export function getProcedimiento(procedure: string): any {
  rellenarProcedimientos()
  let respuesta: any = [];

  /*  for (let index = 0; index < documentos.length; index++) {
       const element = documentos[index];
       if (element.id.localeCompare(procedure ) == 0) {
           index = documentos.length;
           respuesta = element;
       }

   } */
  respuesta = documentos.find(doc => doc.id.localeCompare(procedure) == 0);

  // console.log('procedimiento', respuesta);
  return respuesta;

}

export function getDocumento(documento: string) {
  rellenarProcedimientos();
  // console.log('documento', documento);
  // console.log('documentos', documentos);

  let respuesta: any = '';
  for (let index = 0; index < documentos.length; index++) {
    const element = documentos[index]['informes'];


    for (let index2 = 0; index2 < element.length; index2++) {
      const element2 = element[index2];
      if (element2.id.localeCompare(documento) == 0) {
        // console.log('element2',element2,'documento', documento);

        index2 = element.length;
        index = documentos.length;
        respuesta = element2;
      }

    }

  }
  // console.log('documentos', respuesta);
  return respuesta;

}
//Funcion que devuelve la id del informe [0] del procedimiento al cual se consulta
export function getDocumentoFirstReport(idProc:string){
  rellenarProcedimientos()

  for (let index = 0; index < documentos.length; index++){
    const procedimiento = documentos[index]
    if ( procedimiento.id  == idProc && procedimiento.informes.length > 0){
      return procedimiento.informes[0].id
    }
  }
}



function menuItemsUser() {

  let menuSettings = [
    {
      id: 'usuarios',
      title: 'Control de usuarios',
      full_title: 'Control de usuarios',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'variedades',
      title: 'Variedades',
      full_title: 'Variedades',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'variedades_fruto_hueso',
      title: 'Variedades fruto hueso',
      full_title: 'Variedades fruto hueso',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'prod_camion',
      title: 'Productos camión',
      full_title: 'Productos camión',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'paises',
      title: 'Paises',
      full_title: 'Paises',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'empresas',
      title: 'Empresas',
      full_title: 'Empresas',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'almacenes',
      title: 'Almacenes',
      full_title: 'Almacenes',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'documentos',
      title: 'Generar copia de seguridad',
      full_title: 'Generar copia de seguridad',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'prod_post_cosecha',
      title: 'Prod post cosecha',
      full_title: 'Prod post cosecha',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'tratamientos',
      title: 'Tratamientos',
      full_title: 'Tratamientos',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'calibre',
      title: 'Calibre',
      full_title: 'Calibre',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'materia_activa',
      title: 'Materia activa',
      full_title: 'Materia activa',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    },
    {
      id: 'tipo_residuos',
      title: 'Tipos de residuos',
      full_title: 'Tipos de residuos',
      procedimiento: '',
      procedimiento_num: '',
      registro: '',
      registro_num: '',
      revision: '',
      revision_num: '',

    }

  ];
  return menuSettings;
}

function rellenarProcedimientos() {
  documentos = [];

  if(environment.appName == 'foasat'){

  documentos.push(procedimiento22);
  documentos.push(procedimientoReto);

  }

  if(environment.appName == 'citrosol'){

    documentos.push(procedimiento1);
    documentos.push(procedimiento2);
    documentos.push(procedimiento4);
    documentos.push(procedimiento5);
    documentos.push(procedimiento6);
    documentos.push(procedimiento9);
    documentos.push(procedimiento14);
    documentos.push(procedimiento20);
    documentos.push(procedimiento22);
    documentos.push(procedimientoOtros);
    documentos.push(procedimientoReto);

  }

  // if(environment.appName == 'demo'){

    // documentos.push(procedimiento1);
    // documentos.push(procedimiento2);
    // documentos.push(procedimiento4);
    // documentos.push(procedimiento5);
    // documentos.push(procedimiento6);
    // documentos.push(procedimiento9);
    // documentos.push(procedimiento14);
    // documentos.push(procedimiento20);
    // documentos.push(procedimiento22);
    // documentos.push(procedimientoOtros);
    // documentos.push(procedimientoReto);
    // documentos.push(procedimientoSGA);

  // }

  if(environment.appName == 'tresfrut'){

    documentos.push(procedimiento11);

  }

  if (environment.appName == 'locatec'){
    documentos.push(procedimientoLocatecQualitapp)
  }


  if (environment.appName == 'campanaragricola'){
    // documentos.push(procedimientosCampanar);
    // documentos.push(procedimientosCampanarProveedores);
    // documentos.push(procedimientosCampanarProductos);
  }

  if (environment.appName == 'JoaquinLerma') {
    documentos.push(procedimientoMantenimiento);
  }

  if(environment.appName == "viverosendra" || environment.appName == "herbesmoli" || environment.appName == "decorgandia" ){
    documentos.push(tienda);
  }

}


export function rellenarMenUsuario() {
  rellenarProcedimientos();
  let respuesta: any[] = [];
  /* respuesta.push( {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false }); */
  for (let index = 0; index < documentos.length; index++) {
    const element: informes[] = documentos[index]['informes'];
    for (let index2 = 0; index2 < element.length; index2++) {
      const element2 = element[index2];
      let menu = { id: element2.id, icon: 'fa band-aid', text: element2.full_title, description: element2.full_title, isSelected: false, database: element2.database}
      respuesta.push(menu);
    }
  }
  // respuesta.unshift({id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false })
  // console.log('documentos', respuesta);
  return respuesta;
}

export function rellenarMenuAdmin() {
  rellenarProcedimientos();
  let respuesta: any[] = [];
  let respuesta_item_menu: any[] = [];
  /* respuesta.push( {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false }); */
  for (let index = 0; index < documentos.length; index++) {
    respuesta_item_menu = [];
    const element: informes[] = documentos[index]['informes'];
    for (let index2 = 0; index2 < element.length; index2++) {
      const element2 = element[index2];

      /*   let item_menu = {id: element2.id, fatherId: documentos[index].id, text: element2.full_title,  isSelected: false }
        respuesta.push(item_menu); */
      let item_menu = { id: element2.id, fatherId: documentos[index].id, text: element2.full_title, description: element2.full_title, isSelected: false, database: element2.database }
      respuesta_item_menu.push(item_menu);
    }

    // respuesta_item_menu.push({ id: '', fatherId: '', text: '', description: '', isSelected: false, database: '' });
    let proce = {
      id: documentos[index]['id'],
      icon: documentos[index]['icon'],
      text: documentos[index]['text'],
      description: documentos[index]['description'],
      isSelected: documentos[index]['isSelected'],
      expandable: respuesta_item_menu,
      database: documentos[index]['database']
    }

    //const element: procedimientos[] = documentos[index]['informes'];
    // console.log('element', element[0]);
    // console.log(' documentos[index]',  documentos[index]);
    respuesta.push(proce);



  }
  respuesta.unshift({ id: 'clientes', icon: 'fa fa-home', text: 'Inicio', description: 'Inicio', isSelected: false })
  if (environment.appName === 'campanaragricola'){
    respuesta.push({id: 'app_proveedores', icon: 'fa fa-truck', text: 'Proveedores', description: 'Proveedores', isSelected: false})
    respuesta.push({id: 'app_productos', icon: 'fa fa-cubes', text: 'Productos', description: 'Productos', isSelected: false})
  }
  console.log('documentos', respuesta);
  return respuesta;

}

export function recuperarPrimerProcedimiento(id) {
  documentos = [];
  // documentos.push(procedimiento1);
  // documentos.push(procedimiento2);
  // documentos.push(procedimiento4);
  // documentos.push(procedimiento5);
  // documentos.push(procedimiento6);
  // documentos.push(procedimiento9);
  // documentos.push(procedimiento14);
  // documentos.push(procedimiento20);
  documentos.push(procedimiento22);
  documentos.push(procedimientoReto);
  // documentos.push(procedimientoOtros);

  for (let index = 0; index < documentos.length; index++) {
    const element = documentos[index].id;
    if (element == id) {
      return (documentos[index]['informes'][0].id);
    }
    if ((index + 1) >= documentos.length) {
      return ('Calidad Brio');
    }
  }



}
